module.exports = __webpack_public_path__ + "img/logo.2111e8b4.png";